module.exports = __webpack_public_path__ + "static/media/parking-slash.b3b6f7ad.svg";